import { Box, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ThemeTypography } from 'DesignSystem';
import filter from 'lodash/filter';
import React, { useMemo } from 'react';

interface ICatalogItemThirdPartiesProps {
  items: string[];
}

const StyledUl = styled('ul')(() => ({
  paddingLeft: 30,
}));

const CatalogItemThirdParties: import('react').FC<ICatalogItemThirdPartiesProps> = ({
  items = [],
}) => {
  const firstCol = useMemo(() => filter(items, (item, index) => index % 2 === 0), [items]);
  const secondCol = useMemo(() => filter(items, (item, index) => index % 2 !== 0), [items]);

  return (
    <Box>
      <ThemeTypography variant="BODY_LARGE_BOLD">Trusted third parties</ThemeTypography>

      <Grid container>
        <Grid item xs={6}>
          <StyledUl>
            {firstCol.map((item, index) => (
              <li key={item + index}>{item}</li>
            ))}
          </StyledUl>
        </Grid>
        <Grid item xs={6}>
          <StyledUl>
            {secondCol.map((item, index) => (
              <li key={item + index}>{item}</li>
            ))}
          </StyledUl>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CatalogItemThirdParties;
